/* Responsibility: A listener for touch events on applicable devices */

export default {
    name: 'touchListenerService',
    callable() {
        const PX_PER_MS_SWIPE_THRESHOLD = 0.5;

        const horizontalMovement = function(startEvent) {
            const moves = [
                {
                    x: startEvent.pageX || startEvent.changedTouches[0].pageX,
                    time: new Date(),
                },
            ];

            function weightedAverage() {
                let i;
                let totalWeight = 0;
                let sum = 0;
                for (i = 1; i < moves.length; i += 1) {
                    const distance = moves[i].x - moves[i - 1].x;
                    const timeSinceLast = moves[i].time - moves[i - 1].time;
                    const weight = Math.pow(i, 3); // Add exponentially more weight to more recent movements
                    sum +=
                        distance /
                        (timeSinceLast === 0 ? 1 : timeSinceLast) *
                        weight;
                    totalWeight += weight;
                }
                return sum / totalWeight;
            }

            return {
                add(event) {
                    moves.push({
                        x: event.pageX || event.changedTouches[0].pageX,
                        time: new Date(),
                    });
                    if (moves.length > 20) {
                        moves.shift();
                    }
                },
                end(event) {
                    this.add(event);
                },
                getSwipe() {
                    const weightedAvgPixelsPerSec = weightedAverage();
                    if (weightedAvgPixelsPerSec > PX_PER_MS_SWIPE_THRESHOLD) {
                        return 'right';
                    } else if (
                        weightedAvgPixelsPerSec < -PX_PER_MS_SWIPE_THRESHOLD
                    ) {
                        return 'left';
                    } else {
                        return 'none';
                    }
                },
            };
        };

        function addEventListeners(touchElement) {
            let currentMovement;

            const start = function(e) {
                currentMovement = horizontalMovement(e);
            };

            const move = function(e) {
                e.preventDefault();
                e.stopPropagation();
                currentMovement.add(e);
            };

            const end = function(e) {
                currentMovement.end(e);
                if (currentMovement.getSwipe() !== 'none') {
                    const evt = document.createEvent('Event');
                    const direction = currentMovement.getSwipe();
                    evt.initEvent(direction, true, true);
                    touchElement.dispatchEvent(evt);
                }
            };
            touchElement.addEventListener('touchstart', start, false);
            touchElement.addEventListener('MSPointerDown', start, false);
            touchElement.addEventListener('mousedown', start, false);

            touchElement.addEventListener('touchmove', move, false);
            touchElement.addEventListener('MSPointerMove', move, false);
            touchElement.addEventListener('mousemove', move, false);

            touchElement.addEventListener('touchend', end, false);
            touchElement.addEventListener('MSPointerUp', end, false);
            touchElement.addEventListener('mouseup', end, false);
        }

        return {
            addEventListeners,
        };
    },
};



// WEBPACK FOOTER //
// ./services/touchListenerService.js